import StyledText from '../components/StyledText';

export default function SensorsPage () {
    return (<StyledText>Not available</StyledText>)
}
